export default __webpack_public_path__ + "assets/icons/vn.38e6545e.svg";